import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import classNames from 'classnames';
import { universalStyles, white } from '../../../../app/theme';

const useStyles = makeStyles(() => ({
  ...universalStyles,
  pageList: {
    marginBottom: 30,
  },
  whiteText: {
    color: white,
  },
  header: {
    color: white,
    fontSize: 20,
    fontWeight: 900,
  },
}));

const AcquisitionPage01 = (): JSX.Element => {
  const classes = useStyles();

  return (
    <>
      <Typography variant="h6">
        This training is designed for nuclear medicine technologists to understand the dosing and administration of
        POSLUMA as well as to optimize the image acquisition protocol.
      </Typography>
      <div className={classes.poslumaBox}>
        <Typography className={classes.header}>The Image Acquisition Training contains the following:</Typography>
        <ul className={classNames(classes.poslumaList, classes.whiteText, classes.pageList)}>
          <li>Steps needed to effectively capture optimal quality images</li>
          <li>Questions to ensure understanding of all the training materials</li>
          <ul className={classNames(classes.poslumaNestedList, classes.whiteText)}>
            <li>These are ungraded questions to provide an engaging learning experience</li>
          </ul>
        </ul>
        <Typography className={classes.header}>
          We encourage setting aside 30 minutes to complete this training. If you are interrupted or logged out, you
          will be redirected to the last web page you reviewed upon returning to this training track.
          <br />
          <br />
          <i>To gain access to additional materials, please be sure to fully complete this training.</i>
        </Typography>
      </div>
    </>
  );
};

export default AcquisitionPage01;
